import { IUserAccountStore } from '../index'
import { ITogglePremiumInfoModal } from '../../../actions/userAccount/limit/togglePremiumInfoModal'

export default function(
  store: IUserAccountStore,
  action: ITogglePremiumInfoModal,
) {
  return {
    ...store,
    infoModal: {
      ...store.infoModal,
      open: action.toggle,
    },
    sliderTab: 0,
  }
}
